import { type } from './type.js';

/**
 * @description
 * Checks if `value` is a `RegExp`
 *
 * @example
 * ``` ts
 * isRegexp(/test/);
 * // => true
 * isRegexp('test');
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns Returns true if value is a `RegExp`, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-regexp
 */
export const isRegexp = (value): value is RegExp => {
  return type(value) === 'regexp';
};
